import { render } from "./EditPayrollPayslips.vue?vue&type=template&id=2038018e&scoped=true"
import script from "./EditPayrollPayslips.vue?vue&type=script&lang=js"
export * from "./EditPayrollPayslips.vue?vue&type=script&lang=js"

import "./EditPayrollPayslips.vue?vue&type=style&index=0&id=2038018e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2038018e"]])

export default __exports__